module.exports = __webpack_public_path__ + "img/ic_add_2.1c573bc0.svg";